module.exports = __webpack_public_path__ + "static/media/gallery-7.2baa3b93.jpg";